import { FormikProps, getIn } from 'formik';
// import { type GetFieldCheckboxOutput } from './getFieldCheckboxProps.d';

export const getFieldTagProps = <
	S extends FormikProps<{
		// eslint-disable-next-line
		[key in keyof S['values']]: any;
	}>,
>(
	formik: S,
	name: keyof S['values']
): any => {
	const { values, touched, setFieldValue, errors } = formik;

	const _onValueChange = (value: string[]) => {
		setFieldValue(String(name), value);
	};

	return {
		name: name as string,
		value: getIn(values, String(name)) || [],
		onChange: _onValueChange,
		touched: getIn(touched, String(name)),
		error: getIn(touched, String(name)) ? getIn(errors, String(name)) : '',
	};
};
